import React, {useState, useEffect} from 'react'
// Styles
import './rwl.style.css'
// Actions
import {Base_API} from '../../_actions/matcher'
import {NhealthAction} from '../../_actions/action.api'
// Components
import RewardList_Card from '../../components/RewardList_Card'
import Overlay from '../../components/Overlay'
import RewardDetails from '../../components/RewardDetails'
// Alert
import Swal from 'sweetalert2'
import { useParams } from 'react-router-dom'
import { DecryptedOBJ, EncryptedOBJ, EncryptedText, DecryptedText } from '../../utils/Encryption'
// Line
import useLineLogin from '../../_actions/authLine/lineLogin'
import lineConfig from '../../_actions/authLine/lineConfig'
import { authenAll } from '../../_actions/sso.authen'


function RewardLists(props) {

    const [openDetail, setOpenDetail] = useState(false);
    const [loading, setLoading] = useState(true);
    const [rewardList, setRewardList] = useState([]);
    const [detailData, setDetailData] = useState(null);
    const [campaignData, setCampaignData] = useState(null);
    const [memberData, setMemberData] = useState(null);

    useEffect(() => {
        dataInit();
    }, [])

    const dataInit = async() => {
        let currentURL = EncryptedText(String(location.href).split('?')[0]);
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)

        // await useLineLogin(lineConfig.reward_lists)
        await authenAll(lineConfig.reward_lists);
        let memberCode = await checkUserInit();
        await rewardListInit();
        handlerLoader('inactive');
    }

    const handlerLoader = (status) => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const refInit = () => {
        return new Promise(async resolve => {
            if(ref !== 'ref')
            {
                localStorage.setItem('refredirect', EncryptedText(ref));
            }
            resolve();
        })
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    // console.log('Get Member: ', res);
                    if(res.isSuccess === true)
                    {
                        setMemberData(res.member);
                        resolve(res.member.membercode);
                    }else
                    {
                        if(res.errMessage === 'not found !.')
                        {
                            // go to register member
                            // goToRegisCard();
                        }
                    }
                })
            }else
            {
                await useLineLogin(lineConfig.reward_lists);
            }
        })
    }

    const goToRegisCard = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/welcome-card-register`;
    }

    const campaignInit = () => {
        return new Promise(async resolve => {
            let refRedirect = DecryptedText(localStorage.getItem('refredirect'));
            NhealthAction.GetCampaign(refRedirect).then(data => {
                // console.log('Get Campaign: ', data);
                // set date end
                let p1 = String(data.appendDate).split('('); 
                p1 = String(p1[1]).split(')');
                p1 = Number(p1[0]);
                localStorage.setItem('end-campaign', EncryptedText(p1));
                setCampaignData(data.campaign);
                resolve(data.campaign.id);
            })
        })
    }

    const rewardListInit = () => {
        return new Promise(async resolve => {
            NhealthAction.GetRewardsList()
            .then(res => {
                // console.log('Get Rewards: ', res);
                setRewardList(res.reward);
            })
            resolve();
        })
    }

    const onSelected = async(id) => {
        // console.log("Select ID: ", id)
        await getRewardDetailByID(id);
    }

    const getRewardDetailByID = (id) => {
        return new Promise(async resolve => {
            NhealthAction.GetRewardDetailByID(id)
            .then(res => {
                if(res.isSuccess === true)
                {
                    setDetailData(res.reward);
                    handlerDetail('active');
                    // console.log('Get Reward Detail By ID: ', res);
                }
            })
        })
    }

    const handlerDetail = (status) => {
        if(status === 'inactive')
        {
            setOpenDetail(false);
            document.body.style.overflow = "scroll";
        }else
        {
            setOpenDetail(true);
            document.body.style.overflow = "hidden";
        }
    };

    const handleRedeem = (data) => {
        let formData = new FormData();
        formData.append('rewardid', data.id);
        formData.append('memberid', memberData.id);
        formData.append('membercode', memberData.membercode);
        formData.append('cardid', memberData.cardid);
        formData.append('cardNo', memberData.cardNo);
        NhealthAction.RedeemReward(formData)
        .then(res => {
            // console.log('Redeem Reward: ', res);

            if(res.isSuccess === true)
            {
                localStorage.setItem('redeem-detail', EncryptedOBJ(data));
                window.location.href = `${Base_API.pathWeb}/n-health/redeem-detail`;
                // เปลี่ยน Flow การแสดงผล ( แลกแล้วกลับไปหน้า My Reward ก่อน ถึงจะมี Redeem Code ส่งมา )
                // if(data.hospital.length > 0)
                // {
                //     // คือของรางวัล
                //     window.location.href = `${Base_API.pathWeb}/n-health/redeemreward-detail`;
                // }else
                // {
                //     // คือคูปอง
                //     window.location.href = `${Base_API.pathWeb}/n-health/redeem-detail`;
                // }
            }else
            {
               if(res.errMessage === 'point not enough to burn.') 
                {
                    showAlert('คะแนนไม่เพียงพอ');
                }
                localStorage.setItem('redeem-detail', EncryptedOBJ(data));
            }
            // console.log("Redeem Reward: ", res);
        })
    }

    const showAlert = (msg) => {
        Swal.fire({
            title: "ผิดพลาด",
            text: msg,
            icon: 'error',
            confirmButtonText: 'ตกลง',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        })
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="rwl-container">
                {/* header text */}
                <h1 className="header-text">
                    ของรางวัล
                </h1> 
                {/* title */}
                <p className="title-head">คัดสรรมาเพื่อคุณ</p>
    
                {/* My reward card */}
                {rewardList.length === 0 &&
                    <p className="notfound">ไม่พบข้อมูล</p> 
                }

                <div className="card">
                    {rewardList.map((item, i) => 
                        <RewardList_Card 
                            setOpenDetail={setOpenDetail} 
                            data={item}
                            onSelected={onSelected}
                            key={i} 
                        />
                    )}
                </div>
    
                {/* Reward Details */}
                <RewardDetails 
                    openDetail={openDetail} 
                    setOpenDetail={setOpenDetail} 
                    data={detailData} 
                    handleRedeem={handleRedeem}
                />
                <Overlay setOpenDetail={setOpenDetail} openDetail={openDetail} />
            </div>
        )
    }
}

export default RewardLists